import React, {useEffect, useState} from 'react';
import {Box, VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {BalanceListItem} from './item';
import HeaderBox from './header-box';

import InternalTemplate from '../../../../../../components/templates/internal';
import {StackParamList} from '../../../../../../navigators';

import {SpinnerModal} from '../../../../../../components/modals';
import {EmptyListIcon} from '../../../../../../components/icons';
import IInvoiceFeeSummary from '../../../../../../interfaces/dtos/invoice-fee-summary.interface';
import {useContextState} from '../../../../../../context/sub-client';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'UnpaidedBillListScreen'
>;

const UnpaidedBillListScreen = ({navigation}: ScreenProps) => {
  const [filtered, setFiltered] = useState([] as IInvoiceFeeSummary[]);
  const [searchText, setSearchText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [started, setStarted] = useState(false);
  const {invoiceFeeSummaryList, fetchInvoiceFeeSummaryList} = useContextState();

  const getList = async () => {
    setIsLoading(true);
    setFiltered([]);
    await fetchInvoiceFeeSummaryList();
    setIsLoading(false);
  };

  useEffect(() => {
    if (invoiceFeeSummaryList && started) {
      setFiltered(invoiceFeeSummaryList);
    } else {
      setFiltered([]);
    }
  }, [invoiceFeeSummaryList, started]);

  useEffect(() => {
    getList();
    setStarted(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoBack = () => {
    navigation.navigate('Dashboard');
  };

  const handleSelectItem = (index: number) => {
    navigation.navigate('InvoiceFeesScreen', filtered[index]);
  };

  const handleSearchChange = (value: string) => {
    const search = value.trim().toLowerCase();
    setSearchText(search);

    if (search === '') {
      if (invoiceFeeSummaryList) {
        setFiltered(invoiceFeeSummaryList);
      }

      return;
    }

    if (invoiceFeeSummaryList) {
      const result = invoiceFeeSummaryList.filter((balance: any) => {
        if (balance.id && balance.id.toLowerCase().indexOf(search) > -1) {
          return true;
        }
        if (
          balance.type &&
          balance.type.label.toLowerCase().indexOf(search) > -1
        ) {
          return true;
        }
        if (
          balance.summary &&
          balance.summary.toLowerCase().indexOf(search) > -1
        ) {
          return true;
        }
      });
      setFiltered(result);
    }
  };

  const isOdd = (num: number) => {
    return num % 2;
  };

  const ListContent = () => {
    if (isLoading) {
      return <></>;
    }
    if (invoiceFeeSummaryList?.length === 0 && searchText === '') {
      return (
        <VStack justifyContent="center" alignItems="center" flex={1}>
          <EmptyListIcon marginTop={0} />
        </VStack>
      );
    }
    // /
    if (filtered) {
      return (
        <>
          {filtered.map((feeSumary: IInvoiceFeeSummary, index: number) => (
            <BalanceListItem
              key={`balance-item-${index}`}
              summary={feeSumary}
              onPress={() => handleSelectItem(index)}
              rowType={isOdd(index) ? 'odd' : 'even'}
            />
          ))}
        </>
      );
    }

    return <></>;
  };

  return (
    <InternalTemplate
      title={'screen-balance-list-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'back-dashboard',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <Box paddingX={5}>
        <HeaderBox
          onChangeSearch={handleSearchChange}
          count={filtered.length}
          searchText={searchText}
        />
      </Box>
      <Box marginBottom={20}>
        <ListContent />
      </Box>
    </InternalTemplate>
  );
};
export default UnpaidedBillListScreen;
